import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  grads: [],
  checkedGradExists: null,
};

const getters = {
  getGrads: (state) => state.grads,
  getGradById: (state) => (id) => state.grads.find((x) => x.id == id),
  getCheckedGradExists: (state) => state.checkedGradExists,
};

const actions = {
  async checkGradExists({ commit }, stu_num) {
    try {
      const resp = await api.get(`/grad_check/${stu_num}`);
      if (resp.status == 200) {
        const grad = resp.data.data.grad;
        commit("setCheckedGradExists", grad);
        return 200;
      } else {
        commit("setCheckedGradExists", null);
      }
    } catch (error) {
      commit("setCheckedGradExists", null);
      return error.status;
    }
  },
  async exportGrads() {
    try {
      const resp = await api.get("/grads_export");
      if (resp.status == 200) {
        return resp.status;
      }
    } catch (error) {
      console.log("error", error);
      return error.status;
    }
  },
  async fetchGrads({ commit }) {
    try {
      const resp = await api.get("/grads");
      if (resp.status == 200) {
        const grads = resp.data.data.grads;
        console.log("grads", grads);
        commit("setGrads", grads);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateGrad({ commit }, grad) {
    console.log("grad:", grad);
    grad.isAccepted = grad.isAccepted ? 1 : 0;
    try {
      const id = grad.id;
      grad._method = "patch";

      const resp = await api.post(`/grads/${id}`, grad);
      if (resp.status == 200) {
        const grad = resp.data.data;
        console.log("grad back", grad);
        commit("updateGrad", grad);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addGrad({ commit }, grad) {
    try {
      const resp = await api.post(`/grads`, grad);

      if (resp.status == 201) {
        const grad = resp.data.data;

        commit("addGrad", grad);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteGrad({ commit }, id) {
    try {
      const resp = await api.delete(`/grads/${id}`);

      if (resp.status == 204) {
        commit("deleteGrad", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setCheckedGradExists(state, grad) {
    state.checkedGradExists = grad;
  },
  setGrads(state, grad) {
    state.grads = grad;
  },
  updateGrad(state, grad) {
    const id = grad.id;
    const index = state.grads.findIndex((grad) => grad.id == id);
    if (index !== -1) {
      state.grads[index] = grad;
    }
  },
  addGrad(state, grad) {
    state.grads.unshift(grad);
  },

  deleteGrad(state, id) {
    const index = state.grads.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.grads.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
